import { render, staticRenderFns } from "./WineryPreview_Desktop.vue?vue&type=template&id=2ffa6b0e&scoped=true&"
import script from "./WineryPreview_Desktop.vue?vue&type=script&lang=js&"
export * from "./WineryPreview_Desktop.vue?vue&type=script&lang=js&"
import style0 from "./WineryPreview_Desktop.vue?vue&type=style&index=0&id=2ffa6b0e&prod&lang=css&"
import style1 from "./WineryPreview_Desktop.vue?vue&type=style&index=1&id=2ffa6b0e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ffa6b0e",
  null
  
)

export default component.exports